var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscribe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0a7 7 0 107 7 7 7 0 00-7-7zm.808 10.231h-.269v.538a.538.538 0 11-1.077 0v-.538H5.385a.538.538 0 110-1.077h2.423a.808.808 0 000-1.615H6.192a1.885 1.885 0 010-3.769h.269v-.538a.538.538 0 111.077 0v.538h1.077a.538.538 0 110 1.077H6.192a.808.808 0 000 1.615h1.615a1.885 1.885 0 010 3.769z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscribe);
export default __webpack_public_path__ + "static/media/subscribe.ee0b687a.svg";
export { ForwardRef as ReactComponent };